import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { AuditLog } from "./types";

/**
 * List
 */
export const auditLogListService = (params: {
  page?: number | null;
  limit?: number | null;
  action?: string | null;
  module?: string | null;
  keyword?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<AuditLog>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const auditLogDetailService = (id: number) =>
  RestAPIClient.call<AuditLog>({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail?.replace("{id}", id.toString()),
    config: {
      requireAuthentication: true,
    },
  });
